import React from "react";
import Icon from "@ant-design/icons";

const ReadReceiptsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    fill="none"
    viewBox="0 0 20 21"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M9 14.623l.44.338a1 1 0 001.322-.093L18 7.5M2 12.754l2.721 2.172a1 1 0 001.35-.095L13 7.5"
    ></path>
  </svg>
);

const ReadReceiptsIcon = (props) => {
  return <Icon component={ReadReceiptsSvg} {...props} />;
};

export { ReadReceiptsIcon };
